import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';


const TablePagination = ({ pagination, unfilteredTotal }) => {
  const {
    page, pageSize, pageSizeOptions, totalPages, total, from, to, setPage, setPageSize,
  } = pagination;

  return (
    <div className="om-pagination">
      <div className="om-pagination__summary">
        Wyświetlono {from}–{to} z {total}
        {unfilteredTotal !== undefined && unfilteredTotal !== total
          ? ` (wszystkich: ${unfilteredTotal})`
          : ''}
      </div>

      <label className="om-pagination__size">
        Na stronie:
        <select
          value={pageSize}
          onChange={event => setPageSize(Number(event.target.value))}
          aria-label="Liczba pozycji na stronie"
        >
          {pageSizeOptions.map(size => (
            <option key={size} value={size}>{size}</option>
          ))}
        </select>
      </label>

      <div className="om-pagination__nav">
        <button
          type="button"
          className="om-pagination__btn"
          onClick={() => setPage(0)}
          disabled={page === 0}
          aria-label="Pierwsza strona"
        >
          <ChevronsLeft size={16} />
        </button>
        <button
          type="button"
          className="om-pagination__btn"
          onClick={() => setPage(page - 1)}
          disabled={page === 0}
          aria-label="Poprzednia strona"
        >
          <ChevronLeft size={16} />
        </button>
        <span className="om-pagination__page">Strona {page + 1} z {totalPages}</span>
        <button
          type="button"
          className="om-pagination__btn"
          onClick={() => setPage(page + 1)}
          disabled={page >= totalPages - 1}
          aria-label="Następna strona"
        >
          <ChevronRight size={16} />
        </button>
        <button
          type="button"
          className="om-pagination__btn"
          onClick={() => setPage(totalPages - 1)}
          disabled={page >= totalPages - 1}
          aria-label="Ostatnia strona"
        >
          <ChevronsRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default TablePagination;
